/**
 * Navigation utilities for consistent agent navigation behavior
 */

/**
 * Generates the agent page URL
 * @param agentId - The agent ID to navigate to
 * @returns The agent page URL
 */
export const getAgentPageUrl = (agentId: number | string): string => {
  return `/agents/${agentId}`;
};

/**
 * Navigate to agent page (for use with useNavigate hook)
 * @param navigate - The navigate function from useNavigate hook
 * @param agentId - The agent ID to navigate to
 */
export const navigateToAgent = (
  navigate: (path: string) => void,
  agentId: number | string
): void => {
  const url = getAgentPageUrl(agentId);
  navigate(url);
};
